import { render } from "./fcmPushPopup.vue?vue&type=template&id=5b44541e"
import script from "./fcmPushPopup.vue?vue&type=script&lang=js"
export * from "./fcmPushPopup.vue?vue&type=script&lang=js"

import "./fcmPushPopup.vue?vue&type=style&index=0&id=5b44541e&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__